import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
// import Card from "../../../components/Card/Card";
import GridContainer from '../../../components/grid/GridContainer'
import GridItem from '../../../components/grid/GridItem'
// import Label from '../../../components/typography/Label'
import Paragraph from '../../../components/typography/Paragraph'
import { container, infoColor } from '../../../assets/material-kit-react'
import * as Sentry from '@sentry/browser'
import typographyStyle  from '../../../assets/component/typographyStyle'
import { withLocalize, Translate } from 'react-localize-redux';

Sentry.init({
    dsn: "https://a2a837fdcc7047ee8369a55e2f144948@sentry.io/1337446"
   });

class AboutUs extends Component {

    componentDidCatch(error, errorInfo) {

        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
              scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
          });
          
    }


    render(){
        const { classes }  = this.props
        return (
            <div className={classes.sections}>

                {/* <Card> */}
            
                    <div className={classes.container}>
                        
                        <GridContainer>

                             <GridItem xs={12} sm={12} md={6} className={classes.gridItem}>

                                    <Paragraph>
                                     <h5 className={classes.title}> City Loft</h5> 
                                     <Translate id="contact_us_head"/>
                                    </Paragraph> 
                                
                                    <Paragraph className={classes.paragraph}>

                                         <img className={classes.icon} src={require('../../../images/mark.svg')} alt='icon'/>

                                         <h5 className={classes.subtitle}> 
                                            <Translate id="yoma_land"/>
                                         </h5> 

                                         <Translate id="contact_us_p1"/>
                                         
                                    </Paragraph>

                                    <Paragraph>
                                        <img className={classes.icon} src={require('../../../images/mark.svg')} alt='icon'/> 
                                        <h5 className={classes.subtitle}> 
                                            <Translate id="contact_us_p2_1"/>
                                        </h5> 
                                        <Translate id="contact_us_p2_2"/>
                                    </Paragraph>

                                    <Paragraph>
                                        <img className={classes.icon} src={require('../../../images/mark.svg')} alt='icon'/> 
                                        <h5 className={classes.subtitle}> 
                                            <Translate id="contact_us_p3_1"/>
                                        </h5> 
                                        
                                        <Translate id="contact_us_p3_2"/>
                                    </Paragraph>

                             </GridItem>

                             <GridItem xs={12} sm={12} md={6} className={classes.gridItem}>

                                {/* <Card className={classes.card}> */}
                                    <div className={classes.imageHolder}>
                                     <img className = {classes.image} src={require('../../../images/Carolynn-min.png')} alt={"girl"}/>
                                    </div>
                                   
                                {/* </Card> */}

                            </GridItem>

                        </GridContainer>

                    </div>

                    <footer>
                        <img src={require('../../../images/CityLoftFrame.svg')} alt="Frame"/>
                    </footer>

                {/* </Card> */}

            </div>
        )
    }

}


const styles = theme => ({
    sections: {
        flex: 1,
        minHeight: '100vh',
        background: '#FFFFFF'
    },
    container: {
        ...container,
        background: '#FFFFFF',
        paddingLeft: '20px',
        paddingRight: '20px',
    },
    card: {
        background: "#3f8f9b",
    },
    title: {
        fontSize: "2.0rem",
        fontWeight: "600",
        position: "relative",
        display: "inline",
        fontFamily: '"Poppins"',
        color: infoColor
    },
    subtitle: {
        fontSize: "1rem",
        fontWeight: "600",
        position: "relative",
        display: "inline",
        height: 0.5,
        fontFamily: '"Poppins"',
        color: infoColor
    },
    imageHolder: {
        background: "#3f8f9b",
        marginTop: 30,
        borderRadius: 10,
    },
    image: {
        paddingTop: "40px",
        paddingLeft:"10px",
        paddingRight: "10px",
        height: 700,
        width: "auto",
        resizeMode: "contain"
    },
    label: {
        paddingTop: '200px'
    },
    icon: {
        width: '20px',
        height: '20px',
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    paragraph: {
        ...typographyStyle.paragraphText,
        marginTop: "30px",
    }
})

// fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//         fontSize: "16px",
//         lineHeight: "1.5em",
//         fontWeight: "300",


        


AboutUs.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withLocalize(withStyles(styles)(AboutUs))
